<template>
  <location
    :locationService = locationService
    :transactionService = transactionService
    :productService = productService
  ></location>
</template>

<script>
  // Components
  import Location from '@/components/Common/Rental/Locations/Location'

  // Services
  import locationService from '@/services/rental/location'
  import transactionService from '@/services/rental/transaction'
  import productService from '@/services/rental/product'

  export default {
    components: {
      Location,
    },

    data () {
      return {
        locationService: locationService,
        transactionService: transactionService,
        productService: productService,
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Rental/Locations/Location.vue